import { Lock } from "lucide-react";
import type { Advisory } from "../../lib/qa";

/**
 * THE ONE HARD STOP.
 *
 * A protected-fact violation is the only thing that blocks export, and it is a categorically
 * different object from every advisory: pinned, lock-glyphed, worded "Must fix to export", with
 * NO dismiss and NO override reason. It is driven by the real backend `protected-facts` gate
 * (V0–V9), never a client guess. Resolution is correcting the text; QA then re-runs and it clears.
 * Shape + word carry the severity — never colour alone.
 */
export function ProtectedFactBanner({ violations }: { violations: Advisory[] }) {
  if (!violations.length) return null;
  return (
    <section className="pf-banner" role="alert" data-testid="protected-fact-banner">
      <div className="pf-banner-head">
        <Lock aria-hidden="true" />
        <div className="pf-banner-copy">
          <strong>Must fix to export — a protected fact does not match the canonical source.</strong>
          <span>Protected facts (numbers, dates, currencies, citations, defined terms) are never altered. Correct the text; final QA re-checks it.</span>
        </div>
      </div>
      <ul className="pf-banner-list">
        {violations.map((violation, index) => (
          <li key={`${violation.validator || violation.gateId}-${index}`}>
            {violation.validator ? <code className="pf-banner-code">{violation.validator}</code> : null}
            <span>{violation.message}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
